// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.reset-input th {
  position: relative;
}
.reset-input th input[type=search] {
  width: 100% !important;
}
@media screen and (max-width: 640px) {
  .reset-input th input[type=text] {
    min-width: 120px !important;
  }
}
.reset-input th .reset-close {
  display: none;
  position: absolute;
  top: 0;
  right: 25px;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
  background: #ddd;
  border: none !important;
  text-align: center;
  font-size: 14px;
  padding: 0px !important;
  height: 16px !important;
  width: 16px !important;
  color: #fff;
  line-height: 1.2 !important;
  font-family: Arial !important;
  transform: rotate(45deg) !important;
  -webkit-transform: rotate(45deg) !important;
}
.reset-input th:hover .reset-close {
  display: block;
}

.team-actions {
  width: 130px;
  padding-top: 0;
  padding-bottom: 0;
  line-height: 33px;
  vertical-align: middle;
  text-align: center;
}
.team-actions .btn-xs {
  position: initial !important;
  margin: 2px !important;
}

@media screen and (max-width: 767px) {
  .teams-lists tr .team-actions .btn-xs {
    display: inline-block;
  }
}
@media screen and (max-width: 400px) {
  .teams-lists tr .team-actions .btn-xs {
    display: inline-block;
  }
  .table-striped {
    width: 400px;
  }
}
.pad-left-zero a {
  margin-right: 4px;
  margin-bottom: 10px;
}

::ng-deep.ngx-datepicker-container .ngx-datepicker-calendar-container {
  z-index: 9;
}

::ng-deep.ngx-datepicker-input {
  background-color: #fff !important;
  width: 100% !important;
}

.modal-body .ibox-title {
  padding-left: 0;
  border: none;
  padding-top: 0;
}
.modal-body .ibox-title h5 {
  font-size: 17px;
  font-weight: 500;
}
.modal-body .btn.btn-primary {
  margin-top: 18px;
}

::ng-deep.swal2-modal {
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  justify-content: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
}

::ng-deep .swal2-show {
  background-color: white;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  width: 478px;
  padding: 17px;
  border-radius: 5px;
  text-align: center;
  position: fixed;
  left: 0 !important;
  top: 0 !important;
  transform: translate(0, 0) !important;
  -webkit-transform: translate(0, 0) !important;
  -moz-transform: translate(0, 0) !important;
  margin-left: -256px;
  overflow: hidden;
  z-index: 99999;
  margin-top: -168px;
}
::ng-deep .swal2-show:focus {
  outline: none;
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled {
  background-color: #28a745 !important;
  color: white;
  border: none;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 26px 5px 0 5px;
  cursor: pointer;
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.5);
}
::ng-deep .swal2-show button.swal2-confirm.swal2-styled {
  background-color: #dc3545;
  color: white;
  border: none;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 26px 5px 0 5px;
  cursor: pointer;
}
::ng-deep .swal2-show button.swal2-confirm.swal2-styled:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(220, 53, 58, 0.5);
}
::ng-deep .swal2-show .swal2-icon.swal2-warning {
  width: 80px;
  height: 80px;
  border: 4px solid gray;
  border-radius: 40px;
  border-radius: 50%;
  margin: 20px auto;
  padding: 0;
  position: relative;
  box-sizing: content-box;
  border-color: #F8BB86;
  font-size: 58px;
  color: #F8BB86;
  justify-content: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
}
::ng-deep .swal2-show .swal2-icon.swal2-warning:focus {
  outline: none;
  box-shadow: 0 0 0 3px #F8BB86;
}
::ng-deep .swal2-show h2#swal2-title {
  color: #575757;
  font-size: 30px;
  text-align: center;
  font-weight: 600;
  text-transform: none;
  position: relative;
  margin: 25px 0;
  padding: 0;
  line-height: 40px;
  display: block;
}
::ng-deep .swal2-show h2#swal2-title:focus {
  outline: none;
  box-shadow: 0 0 0 3px #575757;
}
::ng-deep .swal2-show div#swal2-content {
  color: #797979;
  font-size: 16px;
  text-align: center;
  font-weight: 300;
  position: relative;
  text-align: inherit;
  float: none;
  margin: 0;
  padding: 0;
  line-height: normal;
}
::ng-deep .swal2-show div#swal2-content:focus {
  outline: none;
  box-shadow: 0 0 0 3px #797979;
}

.swal2-show button.swal2-cancel.swal2-styled:focus {
  opacity: 1;
  box-shadow: 0 0 0 3px rgba(208, 208, 208, 0.5);
}

::ng-deep .swal2-shown {
  background-color: black;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999999999999;
}

::ng-deep.swal2-modal {
  max-width: 500px !important;
  width: 100% !important;
  left: 0 !important;
  top: 0 !important;
  transform: translate(0, 0) !important;
  -webkit-transform: translate(0, 0) !important;
  -moz-transform: translate(0, 0) !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
  box-sizing: border-box !important;
  bottom: 0;
  right: 0;
  margin: auto !important;
  height: 390px;
}

.error-details {
  color: red;
  display: inline-block;
  padding-top: 8px;
}

.teams-lists tr td:nth-child(4) {
  width: 35%;
}

.table-responsive {
  overflow-x: scroll;
}
.table-responsive table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: transparent;
  border-collapse: collapse;
  border-spacing: 0;
}
.table-responsive table th {
  text-align: left;
}
.table-responsive table th input {
  font: inherit;
}
.table-responsive table th input:focus, .table-responsive table th input:focus-visible {
  outline: none;
  border: 1px solid #1ab394;
}
.table-responsive table th input::-webkit-input-placeholder {
  color: #999;
}
.table-responsive table .form-group {
  margin-bottom: 15px;
}
.table-responsive table label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
.table-responsive table tbody tr td .btn-xs {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
}
.table-responsive table tbody tr:nth-of-type(even):hover {
  background-color: #f5f5f5;
}

::ng-deep .modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
::ng-deep .modal.show {
  display: block !important;
}
::ng-deep .modal.grey {
  background: rgba(236, 236, 236, 0.9);
}
::ng-deep .modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
::ng-deep .modal.fade.in {
  opacity: 1;
}
::ng-deep .modal.in .modal-dialog {
  transform: translate(0, 0);
}
::ng-deep .modal.modal-open {
  overflow-x: hidden;
  overflow-y: auto;
}
::ng-deep .modal .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
@media (min-width: 768px) {
  ::ng-deep .modal .modal-dialog {
    margin: 30px auto;
  }
}
@media (min-width: 768px) and (min-width: 768px) {
  ::ng-deep .modal .modal-dialog--swd {
    width: 300px;
    margin: 30px auto;
  }
}
@media (min-width: 768px) and (min-width: 768px) {
  ::ng-deep .modal .modal-dialog--lwd {
    width: 600px;
    margin: 30px auto;
  }
}
@media (min-width: 768px) and (min-width: 768px) {
  ::ng-deep .modal .modal-dialog--wd {
    width: 900px;
    margin: 30px auto;
  }
}
::ng-deep .modal .modal-dialog .modal-content {
  background-clip: padding-box;
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  outline: 0 none;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content > .modal-dialog {
  width: 900px;
}
::ng-deep .modal .modal-dialog .modal-content .close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
::ng-deep .modal .modal-dialog .modal-content .close:focus-visible, ::ng-deep .modal .modal-dialog .modal-content .close:focus {
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content .close:hover {
  opacity: 0.5;
}
::ng-deep .modal .modal-dialog .modal-content button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  appearance: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form .form-group {
  margin-bottom: 15px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body--addlm form .form-group input,
::ng-deep .modal .modal-dialog .modal-content .modal-body--addlm form .form-group select {
  margin-top: 5px;
  height: 34px;
  font-size: 14px;
  line-height: 1.4;
  font-family: "open sans", sans-serif;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body--addlm form .form-group input:focus, ::ng-deep .modal .modal-dialog .modal-content .modal-body--addlm form .form-group input:focus-visible,
::ng-deep .modal .modal-dialog .modal-content .modal-body--addlm form .form-group select:focus,
::ng-deep .modal .modal-dialog .modal-content .modal-body--addlm form .form-group select:focus-visible {
  outline: none;
  border: 1px solid #1ab394;
}
::ng-deep .modal .f-btn {
  color: #fff;
  font-size: 14px;
  border-color: #73BF38;
  background-color: #73BF38;
}
::ng-deep .modal .f-btn--seagrn {
  background-color: #1dc5a3;
  border-color: #1dc5a3;
}
::ng-deep .modal .f-btn:hover {
  border-color: #4cae4c;
  background-color: #4cae4c;
}
::ng-deep .modal .f-btn--dngr {
  color: #fff;
  border-color: #ED5565;
  background-color: #ED5565;
}
::ng-deep .modal .f-btn--dngr:hover {
  border-color: #ec4758;
  background-color: #ec4758;
}
::ng-deep .modal .f-btn--info {
  color: #fff;
  border-color: #23c6c8;
  background-color: #23c6c8;
}
::ng-deep .modal .f-btn--info:hover {
  border-color: #21b9bb;
  background-color: #21b9bb;
}
::ng-deep .modal .f-btn--wrng {
  color: #fff;
  border-color: #f8ac59;
  background-color: #f8ac59;
}
::ng-deep .modal .f-btn--wrng:hover {
  border-color: #f7a54a;
  background-color: #f7a54a;
}

::ng-deep.modal-open {
  overflow: hidden;
}

.modal-body form input.form-control {
  min-height: 34px;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 1.4;
}
.modal-body form input.form-control:focus, .modal-body form input.form-control:focus-visible {
  border: 1px solid #1ab394;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/admin-learner-maps-list/admin-learner-maps-list.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA5YE;EACE,kBAAA;AA+YJ;AA7YI;EACE,sBAAA;AA+YN;AA3YI;EACE;IACE,2BAAA;EA6YN;AACF;AA1YI;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WDwCa;ECvCb,2BAAA;EACA,6BAAA;EACA,mCAAA;EACA,2CAAA;AA4YN;AAxYM;EACE,cAAA;AA0YR;;AApYA;EACE,YAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;AAuYF;AArYE;EACE,4BAAA;EACA,sBAAA;AAuYJ;;AAnYA;EACE;IACE,qBAAA;EAsYF;AACF;AAnYA;EACE;IACE,qBAAA;EAqYF;EAlYA;IACE,YAAA;EAoYF;AACF;AAhYE;EACE,iBAAA;EACA,mBAAA;AAkYJ;;AA7XE;EACE,UAAA;AAgYJ;;AA5XA;EACE,iCAAA;EACA,sBAAA;AA+XF;;AAzXE;EACE,eAAA;EACA,YAAA;EACA,cAAA;AA4XJ;AA1XI;EACE,eAAA;EACA,gBAAA;AA4XN;AAxXE;EACE,gBAAA;AA0XJ;;AAtXA;EACE,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,uBAAA;EACA,+BAAA;EACA,4BAAA;AAyXF;;AAtXA;EACE,uBAAA;EACA,wEAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,6CAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAyXF;AAvXE;EACE,aAAA;AAyXJ;AAtXE;EACE,oCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAwXJ;AAtXI;EACE,aAAA;EACA,4CAAA;AAwXN;AApXE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAsXJ;AApXI;EACE,aAAA;EACA,4CAAA;AAsXN;AAlXE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,+BAAA;EACA,4BAAA;AAoXJ;AAlXI;EACE,aAAA;EACA,6BAAA;AAoXN;AAhXE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AAkXJ;AAhXI;EACE,aAAA;EACA,6BAAA;AAkXN;AA9WE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AAgXJ;AA9WI;EACE,aAAA;EACA,6BAAA;AAgXN;;AA3WA;EACE,UAAA;EACA,8CAAA;AA8WF;;AA3WA;EACE,uBAAA;EACA,iEAAA;EACA,oCAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,qBAAA;AA8WF;;AA3WA;EACE,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,6CAAA;EACA,0CAAA;EACA,yBAAA;EACA,wBAAA;EACA,iCAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,aAAA;AA8WF;;AA3WA;EACE,UAAA;EACA,qBAAA;EACA,gBAAA;AA8WF;;AA3WA;EACE,UAAA;AA8WF;;AA3WA;EACE,kBAAA;AA8WF;AA5WE;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,yBAAA;EACA,iBAAA;AA8WJ;AA5WI;EACE,gBAAA;AA8WN;AA5WM;EACE,aAAA;AA8WR;AA5WQ;EAEE,aAAA;EACA,yBAAA;AA6WV;AA1WQ;EACE,WAAA;AA4WV;AAtWI;EACE,mBAAA;AAwWN;AArWI;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAuWN;AA5VY;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;AA8Vd;AAxVU;EACE,yBAAA;AA0VZ;;AAjVA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;AAoVF;AAlVE;EACE,yBAAA;AAoVJ;AAjVE;EACE,oCAAA;AAmVJ;AA/UI;EACE,mCAAA;AAiVN;AA9UI;EACE,UAAA;AAgVN;AA3UI;EACE,0BAAA;AA6UN;AAzUE;EACE,kBAAA;EACA,gBAAA;AA2UJ;AAxUE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AA0UJ;AAxUI;EALF;IAOI,iBAAA;EA0UJ;AACF;AAxUQ;EADF;IAEI,YAAA;IACA,iBAAA;EA2UR;AACF;AAvUQ;EADF;IAEI,YAAA;IACA,iBAAA;EA0UR;AACF;AAtUQ;EADF;IAEI,YAAA;IACA,iBAAA;EAyUR;AACF;AArUI;EACE,4BAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AAuUN;AArUM;EACE,YAAA;AAuUR;AApUM;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AAsUR;AApUQ;EAEE,aAAA;AAqUV;AAlUQ;EACE,YAAA;AAoUV;AAhUM;EACE,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EAEA,gBAAA;AAkUR;AA3TU;EACE,mBAAA;AA6TZ;AApTc;;EAEE,eAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;AAsThB;AApTgB;;;EAEE,aAAA;EACA,yBAAA;AAuTlB;AA7SE;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AA+SJ;AA7SI;EACE,yBAAA;EACA,qBAAA;AA+SN;AA5SI;EACE,qBAAA;EACA,yBAAA;AA8SN;AA3SI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AA6SN;AA3SM;EACE,qBAAA;EACA,yBAAA;AA6SR;AAzSI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AA2SN;AAzSM;EACE,qBAAA;EACA,yBAAA;AA2SR;AAvSI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AAySN;AAvSM;EACE,qBAAA;EACA,yBAAA;AAySR;;AAnSA;EACE,gBAAA;AAsSF;;AA/RI;EACE,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;AAkSN;AAhSM;EAEE,yBAAA;EACA,aAAA;AAiSR","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../assets/styles/variables';\n\n.reset-input {\n  th {\n    position: relative;\n\n    input[type=\"search\"] {\n      width: 100% !important;\n\n    }\n\n    @media screen and (max-width: 640px) {\n      input[type=\"text\"] {\n        min-width: 120px !important;\n      }\n    }\n\n    .reset-close {\n      display: none;\n      position: absolute;\n      top: 0;\n      right: 25px;\n      bottom: 0;\n      margin: auto;\n      border-radius: 50%;\n      background: #ddd;\n      border: none !important;\n      text-align: center;\n      font-size: 14px;\n      padding: 0px !important;\n      height: 16px !important;\n      width: 16px !important;\n      color: $color-light-type;\n      line-height: 1.2 !important;\n      font-family: Arial !important;\n      transform: rotate(45deg) !important;\n      -webkit-transform: rotate(45deg) !important;\n    }\n\n    &:hover {\n      .reset-close {\n        display: block;\n      }\n    }\n  }\n}\n\n.team-actions {\n  width: 130px;\n  padding-top: 0;\n  padding-bottom: 0;\n  line-height: 33px;\n  vertical-align: middle;\n  text-align: center;\n\n  .btn-xs {\n    position: initial !important;\n    margin: 2px !important;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .teams-lists tr .team-actions .btn-xs {\n    display: inline-block;\n  }\n}\n\n@media screen and (max-width: 400px) {\n  .teams-lists tr .team-actions .btn-xs {\n    display: inline-block;\n  }\n\n  .table-striped {\n    width: 400px;\n  }\n}\n\n.pad-left-zero {\n  a {\n    margin-right: 4px;\n    margin-bottom: 10px;\n  }\n}\n\n::ng-deep.ngx-datepicker-container {\n  .ngx-datepicker-calendar-container {\n    z-index: 9;\n  }\n}\n\n::ng-deep.ngx-datepicker-input {\n  background-color: #fff !important;\n  width: 100% !important;\n}\n\n\n\n.modal-body {\n  .ibox-title {\n    padding-left: 0;\n    border: none;\n    padding-top: 0;\n\n    h5 {\n      font-size: 17px;\n      font-weight: 500;\n    }\n  }\n\n  .btn.btn-primary {\n    margin-top: 18px;\n  }\n}\n\n::ng-deep.swal2-modal {\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  -moz-flex-wrap: wrap;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -moz-justify-content: center;\n}\n\n::ng-deep .swal2-show {\n  background-color: white;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  width: 478px;\n  padding: 17px;\n  border-radius: 5px;\n  text-align: center;\n  position: fixed;\n  left: 0 !important;\n  top: 0 !important;\n  transform: translate(0, 0) !important;\n  -webkit-transform: translate(0, 0) !important;\n  -moz-transform: translate(0, 0) !important;\n  margin-left: -256px;\n  overflow: hidden;\n  z-index: 99999;\n  margin-top: -168px;\n\n  &:focus {\n    outline: none;\n  }\n\n  button.swal2-cancel.swal2-styled {\n    background-color: #28a745 !important;\n    color: white;\n    border: none;\n    box-shadow: none;\n    font-size: 17px;\n    font-weight: 500;\n    -webkit-border-radius: 4px;\n    border-radius: 5px;\n    padding: 10px 32px;\n    margin: 26px 5px 0 5px;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.5);\n    }\n  }\n\n  button.swal2-confirm.swal2-styled {\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    box-shadow: none;\n    font-size: 17px;\n    font-weight: 500;\n    -webkit-border-radius: 4px;\n    border-radius: 5px;\n    padding: 10px 32px;\n    margin: 26px 5px 0 5px;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(220, 53, 58, 0.5);\n    }\n  }\n\n  .swal2-icon.swal2-warning {\n    width: 80px;\n    height: 80px;\n    border: 4px solid gray;\n    -webkit-border-radius: 40px;\n    border-radius: 40px;\n    border-radius: 50%;\n    margin: 20px auto;\n    padding: 0;\n    position: relative;\n    box-sizing: content-box;\n    border-color: #F8BB86;\n    font-size: 58px;\n    color: #F8BB86;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -moz-justify-content: center;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px #F8BB86;\n    }\n  }\n\n  h2#swal2-title {\n    color: #575757;\n    font-size: 30px;\n    text-align: center;\n    font-weight: 600;\n    text-transform: none;\n    position: relative;\n    margin: 25px 0;\n    padding: 0;\n    line-height: 40px;\n    display: block;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px #575757;\n    }\n  }\n\n  div#swal2-content {\n    color: #797979;\n    font-size: 16px;\n    text-align: center;\n    font-weight: 300;\n    position: relative;\n    text-align: inherit;\n    float: none;\n    margin: 0;\n    padding: 0;\n    line-height: normal;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px #797979;\n    }\n  }\n}\n\n.swal2-show button.swal2-cancel.swal2-styled:focus {\n  opacity: 1;\n  box-shadow: 0 0 0 3px rgba(208, 208, 208, .5);\n}\n\n::ng-deep .swal2-shown {\n  background-color: black;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 999999999999;\n}\n\n::ng-deep.swal2-modal {\n  max-width: 500px !important;\n  width: 100% !important;\n  left: 0 !important;\n  top: 0 !important;\n  transform: translate(0, 0) !important;\n  -webkit-transform: translate(0, 0) !important;\n  -moz-transform: translate(0, 0) !important;\n  margin-left: 0 !important;\n  margin-top: 0 !important;\n  box-sizing: border-box !important;\n  bottom: 0;\n  right: 0;\n  margin: auto !important;\n  height: 390px;\n}\n\n.error-details {\n  color: red;\n  display: inline-block;\n  padding-top: 8px;\n}\n\n.teams-lists tr td:nth-child(4) {\n  width: 35%;\n}\n\n.table-responsive {\n  overflow-x: scroll;\n\n  table {\n    width: 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n    background-color: transparent;\n    border-collapse: collapse;\n    border-spacing: 0;\n\n    th {\n      text-align: left;\n\n      input {\n        font: inherit;\n\n        &:focus,\n        &:focus-visible {\n          outline: none;\n          border: 1px solid #1ab394;\n        }\n\n        &::-webkit-input-placeholder {\n          color: #999;\n        }\n      }\n\n    }\n\n    .form-group {\n      margin-bottom: 15px;\n    }\n\n    label {\n      display: inline-block;\n      max-width: 100%;\n      margin-bottom: 5px;\n      font-weight: 700;\n    }\n\n    tbody {\n\n      tr {\n\n        td {\n\n          .btn {\n\n            &-xs {\n              padding: 1px 5px;\n              font-size: 12px;\n              line-height: 1.5;\n            }\n          }\n        }\n\n        &:nth-of-type(even) {\n          &:hover {\n            background-color: #f5f5f5;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Modal Design\n::ng-deep .modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n\n  &.show {\n    display: block !important;\n  }\n\n  &.grey {\n    background: rgba(236, 236, 236, 0.9);\n  }\n\n  &.fade {\n    .modal-dialog {\n      transition: transform 0.3s ease-out;\n    }\n\n    &.in {\n      opacity: 1;\n    }\n  }\n\n  &.in {\n    .modal-dialog {\n      transform: translate(0, 0);\n    }\n  }\n\n  &.modal-open {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n\n  .modal-dialog {\n    position: relative;\n    width: auto;\n    margin: 10px;\n\n    @media (min-width: 768px) {\n      // width: 600px;\n      margin: 30px auto;\n\n      &--swd {\n        @media (min-width: 768px) {\n          width: 300px;\n          margin: 30px auto;\n        }\n      }\n\n      &--lwd {\n        @media (min-width: 768px) {\n          width: 600px;\n          margin: 30px auto;\n        }\n      }\n\n      &--wd {\n        @media (min-width: 768px) {\n          width: 900px;\n          margin: 30px auto;\n        }\n      }\n    }\n\n    .modal-content {\n      background-clip: padding-box;\n      background-color: #FFFFFF;\n      border: 1px solid rgba(0, 0, 0, 0);\n      border-radius: 4px;\n      box-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n      outline: 0 none;\n      position: relative;\n\n      &>.modal-dialog {\n        width: 900px;\n      }\n\n      .close {\n        float: right;\n        font-size: 21px;\n        font-weight: bold;\n        line-height: 1;\n        color: #000;\n        text-shadow: 0 1px 0 #fff;\n        filter: alpha(opacity=20);\n        opacity: 0.2;\n\n        &:focus-visible,\n        &:focus {\n          outline: none;\n        }\n\n        &:hover {\n          opacity: 0.5;\n        }\n      }\n\n      button.close {\n        padding: 0;\n        cursor: pointer;\n        background: transparent;\n        border: 0;\n        -webkit-appearance: none;\n        appearance: none;\n      }\n\n      .modal-body {\n\n        form {\n\n          .form-group {\n            margin-bottom: 15px;\n          }\n        }\n\n        &--addlm {\n\n          form {\n            .form-group {\n\n              input,\n              select {\n                margin-top: 5px;\n                height: 34px;\n                font-size: 14px;\n                line-height: 1.4;\n                font-family: 'open sans', sans-serif;\n\n                &:focus,\n                &:focus-visible {\n                  outline: none;\n                  border: 1px solid #1ab394;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .f-btn {\n    color: #fff;\n    font-size: 14px;\n    border-color: #73BF38;\n    background-color: #73BF38;\n\n    &--seagrn {\n      background-color: #1dc5a3;\n      border-color: #1dc5a3;\n    }\n\n    &:hover {\n      border-color: #4cae4c;\n      background-color: #4cae4c;\n    }\n\n    &--dngr {\n      color: #fff;\n      border-color: #ED5565;\n      background-color: #ED5565;\n\n      &:hover {\n        border-color: #ec4758;\n        background-color: #ec4758;\n      }\n    }\n\n    &--info {\n      color: #fff;\n      border-color: #23c6c8;\n      background-color: #23c6c8;\n\n      &:hover {\n        border-color: #21b9bb;\n        background-color: #21b9bb;\n      }\n    }\n\n    &--wrng {\n      color: #fff;\n      border-color: #f8ac59;\n      background-color: #f8ac59;\n\n      &:hover {\n        border-color: #f7a54a;\n        background-color: #f7a54a;\n      }\n    }\n  }\n}\n\n::ng-deep.modal-open {\n  overflow: hidden;\n}\n\n\n\n.modal-body {\n  form {\n    input.form-control {\n      min-height: 34px;\n      font-family: 'Open Sans';\n      font-size: 14px;\n      line-height: 1.4;\n\n      &:focus,\n      &:focus-visible {\n        border: 1px solid #1ab394;\n        outline: none;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
